import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const LinkIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="12"
        height="12"
        style={{ width: '12px', height: '12px', flexShrink: 0 }}
        className="lc-link-icon"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M10 13a5 5 0 0 0 7.54.54l1.92-1.92a4 4 0 0 0-5.66-5.66L12 7" />
        <path d="M14 11a5 5 0 0 0-7.54-.54L4.54 12.38a4 4 0 1 0 5.66 5.66L12 17" />
    </svg>
);

interface RichTextProps {
    text: string;
}

/**
 * רינדור תשובה בפורמט Markdown:
 * - כותרות, רשימות, בולד
 * - לינקים עם אייקון
 * - ריווח מאוד צמוד בווידג׳ט
 */
export function RichText({ text }: RichTextProps) {
    if (!text?.trim()) return null;

    return (
        <div className="lc-break-anywhere">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    p: ({ node, ...props }) => (
                        <p
                            className="lc-text-sm lc-leading-tight lc-mb-0.5 last:lc-mb-0"
                            {...props}
                        />
                    ),
                    ul: ({ node, ...props }) => (
                        <ul
                            className="lc-list-disc lc-pr-4 lc-text-sm lc-leading-tight lc-mb-0.5 last:lc-mb-0"
                            {...props}
                        />
                    ),
                    ol: ({ node, ...props }) => (
                        <ol
                            className="lc-list-decimal lc-pr-4 lc-text-sm lc-leading-tight lc-mb-0.5 last:lc-mb-0"
                            {...props}
                        />
                    ),
                    li: ({ node, ...props }) => (
                        <li
                            className="lc-break-anywhere lc-mb-0.5 last:lc-mb-0"
                            {...props}
                        />
                    ),
                    strong: ({ node, ...props }) => (
                        <strong className="lc-font-semibold" {...props} />
                    ),
                    em: ({ node, ...props }) => (
                        <em className="lc-italic" {...props} />
                    ),
                    a: ({ node, href, children, ...props }) => (
                        <a
                            href={href}
                            dir="ltr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lc-inline-flex lc-items-center lc-gap-1 lc-text-[13px] lc-font-medium lc-underline-offset-2 hover:lc-underline"
                            style={{ color: 'var(--longchat-primary, #FF3E6C)' }}
                            {...props}
                        >
                            <LinkIcon />
                            <span className="lc-break-anywhere">{children}</span>
                        </a>
                    ),
                }}
            >
                {text}
            </ReactMarkdown>
        </div>
    );
}